<template>
  <li class="tag">
    <a
      :class="active ? 'selected' : ''"
      :title="name"
      href="#"
      @click.prevent="toggle"><span>{{ name }}</span></a>
  </li>
</template>

<script>
export default {
  name: 'MVMTag',
  data () {
    return {
    }
  },

  props: {
    name: String,
    active: {
      type: Boolean
    }
  },

  methods: {
    toggle () {
      this.$emit('toggle', { name: this.name, active: !this.active })
    }
  }
}
</script>
